export default __webpack_public_path__ + "static/media/lyrata.2e915120.jpg";